import { Indicator, Text as MantineText } from '@mantine/core';
import { IconInbox } from '@tabler/icons';
import { FC } from 'react';

interface Props {
  unreadCount?: number | null;
}

const InboxIconWithIndicator: FC<Props> = ({ unreadCount }) => {
  const count = unreadCount ?? 0;

  return (
    <Indicator
      inline
      disabled={!count}
      radius="xl"
      offset={-2}
      size={20}
      color="red"
      label={
        <MantineText color="white" size={10}>
          {count}
        </MantineText>
      }
    >
      <IconInbox />
    </Indicator>
  );
};

export default InboxIconWithIndicator;
